



































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import {
  UnitOwnerData,
  viewUnitOwner,
  emptyOwner
} from '@/api/heritageUnit/unitOwner'
import UnitRspbltyView from './responsibility.vue'
import DynamicFiles from '@/components/upload/dynamicFiles.vue'

@Component({
  components: { UnitRspbltyView, DynamicFiles }
})
export default class UnitOwnerView extends Vue {
  public name = 'UnitOwnerView'
  public expandNames: string[] = ['info']
  public loading = false
  public hasAttach: boolean = false
  public form = Object.assign({}, emptyOwner)
  public $refs!: {
    dynamicFilesCtrl: DynamicFiles
    unitRspbltyCtrl: UnitRspbltyView
  }
  //数据加载
  public loadData(unitId: number) {
    if (unitId == 0) {
      this.$message({
        message: '文保单位未匹配，请检查',
        type: 'warning'
      })
      console.log('UnitId为0，请赋值')
    } else {
      this.fetchData(unitId)
    }
  }
  public fetchData(unitId: number) {
    this.loading = true
    viewUnitOwner(unitId)
      .then((response: { data: any }) => {
        this.form = response.data
        this.setCtrls()
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
  public setCtrls() {
    this.setAttach()
  }
  public setAttach() {
    const attachs = this.form.DynamicAttachs
    this.hasAttach = attachs.length > 0
    if (this.hasAttach) {
      this.$nextTick(() => {
        if (this.$refs.dynamicFilesCtrl) {
          this.$refs.dynamicFilesCtrl.setData(attachs)
        }
      })
    }
  }
}
